import {AfterViewInit, Component, Inject, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {DialogContentExampleDialog} from '../dialogCreerElement/dialogCreerElement';

interface ModalData {
    'noTranslatedTitle': string;
    'data': string[];
}

/**
 * Utiliser pour selection un string parmis une liste enorme de string (> 1000)
 * - Mettre un mat-list avec un steper pour economiser la memoire (ou virtual scroll si possible)
 * - Ajouter une recherche
 * - L'appel du dialog doit etre en async, quand on retourne le result cela doit correspondre à undefine si on a rien selectioné sinon le str choisis dans la liste
 */
@Component({
  // tslint:disable-next-line:component-selector
    selector: 'dialog-select-str',
    templateUrl: 'dialog-select-str.html',
    styleUrls: ['dialog-select-str.css']
})
// tslint:disable-next-line:component-class-suffix
export class DialogSelectStr implements AfterViewInit {

  public static async openDialog(dialog: MatDialog, arrayStr: string[], noTranslatedTitle: string): Promise<string> {
    const modalData: ModalData = {
      data: arrayStr,
      noTranslatedTitle: noTranslatedTitle
    };
    const openedDialog = dialog.open(DialogSelectStr, { width: '900px', data: modalData });
    return await openedDialog.afterClosed().toPromise();
  }

  @ViewChild(MatPaginator) mMatPaginator!: MatPaginator;
  @ViewChild(MatSort) mMatSort!: MatSort;

  public HTML_Title = this.mDialogData.noTranslatedTitle;

  public mData: string[] = [...this.mDialogData.data];
  public mFilteredData: string[] = [...this.mData];
  public mPaggedData: string[] = [];

  constructor(private mDialogRef: MatDialogRef<DialogContentExampleDialog>,
              @Inject(MAT_DIALOG_DATA) private mDialogData: ModalData) { }

  ngAfterViewInit() {
    // Init du numbre total d'element dans le paginator
    setTimeout(() => {
      this.mMatPaginator.length = this.mFilteredData.length;
      this.setPaggedData();
    });
  }

  public onPaginatorPageEvent(event: PageEvent) {
    //console.log('event', event);
    this.setPaggedData();
  }

  public applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.mFilteredData = this.mData.filter((elem) => elem.includes(filterValue) || elem === filterValue);
    this.mMatPaginator.length = this.mFilteredData.length;
    this.mMatPaginator.firstPage();
    if (this.mMatPaginator.pageIndex == 0)
      this.setPaggedData(); // L'evenement du changement de page n'est pas trigger si on est déja sur la page 1
  }

  public onItemSelect(item?: string) {
    this.mDialogRef.close(item);
  }

  public setPaggedData() {
    const pageIndex = this.mMatPaginator.pageIndex;
    const pageSize = this.mMatPaginator.pageSize;
    const start = (pageIndex) * pageSize;
    // Pour le slice le end est exclusif donc on prend la longeur total du tableau comme min
    const end = Math.min((pageIndex + 1) * pageSize, this.mFilteredData.length);
    console.log(`getPaggedElement -> start ${start}, end ${end}`);
    this.mPaggedData = this.mFilteredData.slice(start, end);
  }
}
